@if ('owner' | hasAccess) {
<tvd-trial-banner />
}
<!-- @if (loggedIn()) { <zyn-navbar /> } -->

<div zynRootContainer>
  <router-outlet />
</div>
@if (!isSM() && loggedIn()) {
<tvd-bottom-bar (hasBackdrop)="backdrop.set($event)" />
<div
  class="absolute top-0 left-0 h-full w-full bg-black/40 z-[9997] transition-all duration-200 ease-out opacity-0"
  (click)="$event.stopPropagation(); closePanel()"
  [class.opacity-100]="backdrop()"
  [class.invisible]="!backdrop()"
></div>
}

<tvd-cookie-consent-banner />
